module.exports = __webpack_public_path__ + "static/media/datasheet_listData_row2_appleQRcode.81ba29e3.png";